import { RavenIcon } from "../../assets/RavenIcon";
import { HeaderButton } from "./components/HeaderButton";

export const Header = () => {
  return (
    <div className="bg-black text-white sticky top-0 z-50">
      <header className="w-full h-14  flex items-center mx-auto  max-w-7xl">
        <HeaderButton
          className="px-5"
          buttonWidth="w-24"
          navigationPath="/"
          isNoChanged
        >
          <RavenIcon className="w-12 mt-1" />
        </HeaderButton>
        {/* <HeaderButton navigationPath="/home">
        <span>HOME</span>
      </HeaderButton> */}
        <HeaderButton navigationPath="/portfolio">
          <span>PORTFOLIO</span>
        </HeaderButton>
        {/* <HeaderButton navigationPath="/blog">
        <span>BLOG</span>
      </HeaderButton> */}
        <HeaderButton className="pr-5" navigationPath="/contacts">
          <span>CONTACTS</span>
        </HeaderButton>
      </header>
    </div>
  );
};
